module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tableRelatorios",
    attrs: {
      "id": "container-printer"
    }
  }, [_c('div', {
    staticClass: "printer-page"
  }, [_vm._v("'\n    "), _vm._m(0), _vm._v(" "), _c('table', [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.dados), function(s) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm._f("formatDate")(s.dataInicio.date, 'DD/MM/YYYY HH:mm')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatDate")(s.dataInicioRecolhimento.date, 'DD/MM/YYYY HH:mm')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatDate")(s.dataEntrega.date, 'DD/MM/YYYY HH:mm')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(s.categoria ? s.categoria.nome : ''))]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(_vm.calcKM(s)) + "km em " + _vm._s(_vm.diff(s.dataInicio, s.dataEntrega)) + "m\n        ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(s.reboquista ? s.reboquista.nome : ''))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "wrapper text-center"
  }, [_c('div', [_vm._v("Total de veículos: "), _c('strong', [_vm._v(_vm._s(Array.isArray(_vm.dados) && _vm.dados.length))])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-center hidden-print"
  }, [_c('a', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.print()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Imprimir\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "visible-print text-center m-t m-b"
  }, [_c('h1', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("Atenção: O layout deste relatório será customizado de acordo às necessidades do Detran")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Solicitação")]), _vm._v(" "), _c('th', [_vm._v("Recolhimento")]), _vm._v(" "), _c('th', [_vm._v("Entrega")]), _vm._v(" "), _c('th', [_vm._v("Porte")]), _vm._v(" "), _c('th', [_vm._v("Trajeto percorrido")]), _vm._v(" "), _c('th', [_vm._v("Reboquista")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63a6c95c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/relatorios/components/TableRelatorios.vue
// module id = 1739
// module chunks = 17